import { addDays, isBefore } from 'date-fns';
import { TourneyStatus } from 'modules/tournaments/domain/enums/tourney-status';
import { Championship, FetchChampionshipsResponseDto } from 'modules/tournaments/domain/interfaces/responce-dto';
import { baseApi } from 'shared/api/base-api';

export interface ListChampionshipsArgs {
  tournamentId: number;
  limit: number;
  offset: number;
  namePart?: string;
  afterDate?: string;
  beforeDate?: string;
}

const getChampionshipsQuery = `#graphql
query getTournamentChampionships($id: Int!, $limit: Int, $offset: Int, $beforeDate: String, $afterDate: String, $namePart: String) {
  championshipsPaginated(input: {
    tournamentId: $id,
    limit: $limit,
    offset: $offset,
    beforeDate: $beforeDate,
    afterDate: $afterDate,
    namePart: $namePart
  }) {
    id
    name
    startDate
    endDate
    locations {
      id
      address {
        city
        country
      }
    }
  }
}
`;

// Примечание: бэкенд сейчас не возвращает total/totalCount для championshipsPaginated
// Возвращаем плоский массив Championship[], а инвалидацию делаем по id + PARTIAL-LIST
export const championshipsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listChampionships: build.query<Championship[], ListChampionshipsArgs>({
      query: ({ tournamentId, limit, offset, beforeDate, afterDate, namePart }) => ({
        query: getChampionshipsQuery,
        variables: { id: tournamentId, limit, offset, beforeDate, afterDate, namePart },
      }),
      transformResponse: (raw: FetchChampionshipsResponseDto): Championship[] => {
        if (raw?.championshipsPaginated) {
          return raw.championshipsPaginated.map((championship) => {
            const applicationsDeadline = addDays(Date.now(), 3);
            const areApplicationsClosed = championship.endDate && isBefore(new Date(championship.endDate), applicationsDeadline);
            championship.status = areApplicationsClosed ? TourneyStatus.CLOSE : TourneyStatus.OPEN;

            return championship;
          });
        }

        return [];
      },
      providesTags: (result) =>
        result && result.length
          ? [
              ...result.map((c) => ({ type: 'Championship' as const, id: c.id })),
              { type: 'Championship' as const, id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Championship' as const, id: 'PARTIAL-LIST' }],
      keepUnusedDataFor: 60, // секунд — кэш живёт после отписки
    }),
  }),
  overrideExisting: false,
});

export const { useListChampionshipsQuery } = championshipsApi;
